import React from 'react';
import {Navigate, Route, Routes, useParams} from 'react-router-dom';

import {AssignedUsersTab} from './assigned-users';
import {ProfileHistorySwitch} from './profile-history';
import {ProfileSettings} from './profile-settings';

export const RoleProfile = () => {
    const queryParams = useParams<{roleId: string}>();
    const roleId = queryParams.roleId ? +queryParams.roleId : -1;

    return (
        <Routes>
            <Route path="/permissions" element={<ProfileSettings/>}/>
            <Route path="/assigned-users" element={<AssignedUsersTab/>}/>
            <Route path="/history/*" element={<ProfileHistorySwitch/>}/>

            <Route
                path="*"
                element={<Navigate to={`/roles/${roleId}/permissions`} replace={true}/>}
            />
        </Routes>
    );
};
